/**
 * Icon system: authored SVG, 24px grid, stroke 1.75, round caps/joins.
 * One weight everywhere; stroke = currentColor.
 */
import type { JSX } from 'preact'

const P: Record<string, string[]> = {
  home: ['M3 10.5 12 3.5l9 7V20a1 1 0 0 1-1 1h-5v-6h-6v6H4a1 1 0 0 1-1-1Z'],
  bell: ['M6 9a6 6 0 1 1 12 0c0 5 2 6.5 2 6.5H4S6 14 6 9', 'M10.3 20a2 2 0 0 0 3.4 0'],
  user: ['M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z', 'M4 21c0-4 3.6-6 8-6s8 2 8 6'],
  users: ['M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5', 'M16 4.6a3.5 3.5 0 0 1 0 6.8', 'M18.5 14.7c2 .8 3 2.4 3 4.8'],
  search: ['M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z', 'm20 20-3.2-3.2'],
  pencil: ['M4 20l1-4L16.5 4.5a2.12 2.12 0 0 1 3 3L8 19l-4 1Z', 'm14.5 6.5 3 3'],
  star: ['m12 3.2 2.6 5.6 6.1.8-4.4 4.3 1.1 6-5.4-2.9-5.4 2.9 1.1-6L3.3 9.6l6.1-.8L12 3.2Z'],
  repeat: ['m17 2 4 4-4 4', 'M21 6H7a4 4 0 0 0-4 4v1', 'm7 22-4-4 4-4', 'M3 18h14a4 4 0 0 0 4-4v-1'],
  bookmark: ['M6 3.5h12a.5.5 0 0 1 .5.5v16.6L12 17l-6.5 3.6V4a.5.5 0 0 1 .5-.5Z'],
  reply: ['M21 11.5c0 4.4-4 8-9 8-1.5 0-3-.3-4.2-.9L3 20l1.4-3.8A7.4 7.4 0 0 1 3 11.5c0-4.4 4-8 9-8s9 3.6 9 8Z'],
  more: ['M5.5 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z', 'M11 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z', 'M16.5 12a1 1 0 1 0 2 0 1 1 0 0 0-2 0Z'],
  x: ['m5 5 14 14', 'M19 5 5 19'],
  check: ['m4.5 12.5 5 5L19.5 7'],
  image: ['M5 5h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z', 'M8.5 11a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z', 'm4 17.5 4.5-4.5 3.5 3.5 4-4 4 4'],
  poll: ['M6 20v-6', 'M12 20V10', 'M18 20V5'],
  globe: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M3.5 12h17', 'M12 3c2.5 2.5 4 5.5 4 9s-1.5 6.5-4 9c-2.5-2.5-4-5.5-4-9s1.5-6.5 4-9Z'],
  lock: ['M5 11h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1Z', 'M8 11V8a4 4 0 0 1 8 0v3'],
  at: ['M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M15.5 8.5V13a3 3 0 0 0 5.2 2A9.5 9.5 0 1 0 18 19.6'],
  list: ['M9 6h11', 'M9 12h11', 'M9 18h11', 'M4.5 6a1 1 0 1 0 0 .01', 'M4.5 12a1 1 0 1 0 0 .01', 'M4.5 18a1 1 0 1 0 0 .01'],
  sliders: ['M4 6h16', 'M4 12h16', 'M4 18h16', 'M8 6a2 2 0 1 0 0-.01', 'M15 12a2 2 0 1 0 0-.01', 'M10 18a2 2 0 1 0 0-.01'],
  logout: ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
  'chevron-down': ['m6 9 6 6 6-6'],
  'chevron-up': ['m6 15 6-6 6 6'],
  'chevron-left': ['m15 6-6 6 6 6'],
  'chevron-right': ['m9 6 6 6-6 6'],
  'external-link': ['M14 4h6v6', 'M20 4 10 14', 'M18 13v6a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6'],
  eye: ['M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z', 'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z'],
  'eye-off': ['M4 4l16 16', 'M10.6 5.9A9.8 9.8 0 0 1 12 5.5c6 0 9.5 6.5 9.5 6.5a17.5 17.5 0 0 1-3.2 3.9', 'M6.6 6.6A17 17 0 0 0 2.5 12S6 18.5 12 18.5c1.6 0 3-.4 4.3-1', 'M9.9 9.9a3 3 0 0 0 4.2 4.2'],
  trash: ['M4 7h16', 'M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2', 'm6 7 1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13', 'M10 11v6', 'M14 11v6'],
  alert: ['M12 3 2.5 20h19L12 3Z', 'M12 9.5v5', 'M12 17.5a.01.01 0 0 0 0 .01'],
  'arrow-up': ['M12 20V5', 'm5 12 7-7 7 7'],
  clock: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M12 7v5l3 2'],
  hash: ['M5 9h14', 'M4 15h14', 'm10 4-2 16', 'm16 4-2 16'],
  mail: ['M3 5h18a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z', 'm3 7 9 6 9-6'],
  inbox: ['M3 13h5l2 3h4l2-3h5', 'M5 5h14a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1Z'],
  'user-plus': ['M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5', 'M19 8v6', 'M16 11h6'],
  'user-minus': ['M9 11.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z', 'M2.5 20c0-3.5 3-5.5 6.5-5.5s6.5 2 6.5 5.5', 'M16 11h6'],
  'volume-x': ['M11 5 6.5 9H3v6h3.5L11 19V5Z', 'm16 9 5 5', 'm21 9-5 5'],
  plus: ['M12 5v14', 'M5 12h14'],
  send: ['m21.5 2.5-11 11', 'M21.5 2.5 15 22l-3.5-8.5L3 10l18.5-7.5Z'],
  shield: ['M12 3l8 3v5c0 5-3.5 8.5-8 10-4.5-1.5-8-5-8-10V6l8-3Z'],
  link: ['M10 13a5 5 0 0 0 7.5.5l2-2a5 5 0 0 0-7-7l-1.2 1.2', 'M14 11a5 5 0 0 0-7.5-.5l-2 2a5 5 0 0 0 7 7l1.2-1.2'],
  heart: ['M12 20.5 4.5 13a4.7 4.7 0 0 1 6.6-6.7l.9.8.9-.8a4.7 4.7 0 0 1 6.6 6.7L12 20.5Z'],
  smile: ['M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z', 'M9 10h.01', 'M15 10h.01', 'M8.5 14.5c1 1.2 2.2 1.8 3.5 1.8s2.5-.6 3.5-1.8'],
  refresh: ['M20 12a8 8 0 1 1-2.3-5.7L21 9', 'M21 4v5h-5'],
  pin: ['M12 3v8', 'M8.5 3h7', 'M12 11c0 4-1 6-4.5 9h9c-3.5-3-4.5-5-4.5-9Z', 'M7 21h10'],
  sparkle: ['m12 3 1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3Z', 'm18.5 15.5.6 1.6 1.6.6-1.6.6-.6 1.6-.6-1.6-1.6-.6 1.6-.6.6-1.6Z'],
  upload: ['M12 16V4', 'm7 9 5-5 5 5', 'M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3'],
  download: ['M12 4v12', 'm7 11 5 5 5-5', 'M4 15v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3'],
  file: ['M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z', 'M14 3v5h5', 'M9 13h6', 'M9 17h6'],
  mic: ['M12 3a3 3 0 0 1 3 3v5a3 3 0 0 1-6 0V6a3 3 0 0 1 3-3Z', 'M5 11a7 7 0 0 0 14 0', 'M12 18v3', 'M9 21h6'],
  wifi: ['M2.5 9a15 15 0 0 1 19 0', 'M5.5 12.5a11 11 0 0 1 13 0', 'M8.7 16a6.5 6.5 0 0 1 6.6 0', 'M12 19.5a.01.01 0 0 0 0 .01'],
  'wifi-off': ['m2 2 20 20', 'M8.5 16.4a6 6 0 0 1 7-.1', 'M5.5 12.5a11 11 0 0 1 3.2-2.1', 'M2.5 9a15 15 0 0 1 6-3.6', 'M22.5 9a15 15 0 0 0-9.4-3.9', 'M12 19.5a.01.01 0 0 0 0 .01'],
}

export type IconName = keyof typeof P

export function Icon({ name, size = 20, ...rest }: { name: IconName | string; size?: number } & JSX.SVGAttributes<SVGSVGElement>) {
  const paths = P[name]
  if (!paths) return null
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.75"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      {...rest}
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  )
}
